import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { addQuotes } from 'apps/utils';

import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { StyledLink } from 'legacyComponents/styled/lib';
import { ContentWrapper } from 'apps/notificationCenter/styles';

const CreateCard = props => {
  const { t, notification } = props;
  const { target, targetApp } = notification;

  if (!notification || !targetApp) return null;

  const { snippet } = targetApp;

  const cardAction =
    target?.__typename && targetApp?.forum ? t('Posted a') : t('Created a');

  const createdWhere = target?.__typename && targetApp?.forum && (
    <Trans>
      {' '}
      {'into'}{' '}
      <StyledLink {...targetApp?.forum?.route}>
        {targetApp?.forum?.name}
        {"'s forum"}
      </StyledLink>
    </Trans>
  );

  const message = (
    <ContentWrapper>
      <Paragraph>
        {cardAction}{' '}
        <StyledLink {...targetApp?.route}>
          <strong>{target?.__typename}</strong>
        </StyledLink>
        {createdWhere}.
      </Paragraph>
      {snippet && <Paragraph as='blockquote'>{addQuotes(snippet)}</Paragraph>}
    </ContentWrapper>
  );

  return <BaseCard notification={notification} message={message} />;
};

CreateCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
  routerStore: PropTypes.object,
};

export default withNamespaces()(observer(CreateCard));
